import { createRouter, createWebHistory } from 'vue-router';
import Homepage from '../screens/Homepage.vue';
import PageSymabio from '../screens/PageSymabio.vue'; // ton composant
import PageMembres from '../screens/PageMembres.vue'; // ton composant
import SymabioMembres from '../screens/SymabioMembres.vue'; // ton composant
import Reglement from '../screens/Reglement.vue'; // ton composant
import PageDetailsMembre from '../screens/PageDetailsMembre.vue'; // ton composant

const routes = [
  { path: '/', component: Homepage },
  { path: '/about', component: PageSymabio },
  { path: '/pagemembres', component: PageMembres },
  { path: '/membres', component: SymabioMembres },
  { path: '/reglement', component: Reglement },
  { path: '/details', component: PageDetailsMembre },
  {
    path: '/detailsMembres/:id',
    name: 'PageDetailsMembre', // Added name
    component: PageDetailsMembre,
    props: true // Enabled props
  }  
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
